import Alert from './alert-TEMPLATE_VERSION'

export default Alert
